import React from 'react';
import { createPortal } from 'react-dom';
import '../Dialog/Dialog.css'
import Loading from '../Loading/Loading';
import { loadingColors } from '../Loading/Loading';
import { PopWell } from '../Dialog/PopParts';

const LoadingDialog = ({id, txt}) => {
    const dialog = (
        <div className='dialog' id={id}>
            <div className='pop-shell pop-loading' role="status" aria-live="polite">
                <PopWell className="pop-spin">
                    <Loading id="dialog-loading" color={loadingColors["white"]}/>
                </PopWell>
                {txt != undefined && <span className='pop-loading-txt'>{txt}</span>}
            </div>
        </div>
    );

    return createPortal(dialog, document.body);
}

export default LoadingDialog;
